import React, { useRef, useState } from 'react'
import Flex from 'typescript-styled-flex'
import { FiChevronDown, FiChevronUp } from 'react-icons/fi'
import { addDays, differenceInDays, format, isDate } from 'date-fns'
import { useMediaQuery } from '@material-ui/core'
import DatePicker from '../../../../../components/FormBuilder/DatePicker/DatePicker'
import ArrowButton from '../../../../../components/Notifications/ArrowButton'
import DateFormatter from '../../../../../components/Calendar/DateFormatter'

function MobileDatePicker({
  startDate,
  finishDate,
  changeDate,
  minDate,
  maxDate,
}: IMobileDatePickerProps & IMobileDatePickerDispatch) {
  const [show, toggleShow] = useState(false)
  const anchor = useRef(null as HTMLDivElement)
  const width = useMediaQuery('(max-width: 321px)')

  function openPicker() {
    toggleShow(true)
  }

  function closePicker() {
    toggleShow(false)
  }

  function change(date) {
    const diff = Math.abs(differenceInDays(startDate, finishDate))
    changeDate(date, addDays(date, diff))
  }

  if (!isDate(startDate)) {
    return <></>
  }

  return (
    <>
      <Flex
        row={true}
        alignCenter={true}
        style={{ fontSize: '13px' }}
        onClick={openPicker}
        ref={anchor}
      >
        <Flex
          column={true}
          full={true}
          justifyCenter={true}
          alignCenter={true}
          style={{ maxWidth: width ? '115px' : '155px', minWidth: '115px' }}
        >
          <Flex column={true}>
            <Flex row={true}>
              <DateFormatter
                style={{
                  ...{
                    overflow: 'hidden',
                    textOverflow: 'ellipsis',
                    whiteSpace: 'nowrap',
                  },
                  ...(width ? { maxWidth: '60px' } : { maxWidth: '70px' }),
                }}
                date={startDate}
                dateFormat={'D MMM'}
              />
              <div> -</div>
              <DateFormatter
                style={{
                  ...{
                    overflow: 'hidden',
                    textOverflow: 'ellipsis',
                    whiteSpace: 'nowrap',
                  },
                  ...(width ? { maxWidth: '55px' } : { maxWidth: '70px' }),
                }}
                date={finishDate}
                dateFormat={'D MMM'}
              />
            </Flex>
            <div>{format(finishDate, 'YYYY')}</div>
          </Flex>
        </Flex>
        <ArrowButton style={{ marginLeft: 0 }}>
          {!show ? <FiChevronDown /> : <FiChevronUp />}
        </ArrowButton>
      </Flex>
      {show && (
        <>
          <DatePicker
            open={show}
            onClose={closePicker}
            onDateChange={change}
            initialDate={startDate}
            anchorEl={anchor.current}
            minDate={minDate}
            maxDate={maxDate}
          />
        </>
      )}
    </>
  )
}

export default MobileDatePicker

export interface IMobileDatePickerProps {
  startDate: Date
  finishDate: Date
  minDate?: Date
  maxDate?: Date
}

export interface IMobileDatePickerDispatch {
  changeDate: (startDate: Date, finishDate: Date) => void
}
